export enum OptimizelyExperiments {
  cruiseNewBookingFlow = 'cruise_new_cruisebank_booking_flow_may_2024',
  isSupportAssistantEnabled = 'opex_support_assistant_customer_pool',
  lereSearchModelV4 = 'lere_search_model_v4',
  supportAssistantWidgetEnabled = 'opex_lesa_widget',
  expediaStyleLoginPrompt = 'expedia_style_login_prompt',
  emailChangeEnabled = 'opex_email_change',
  signUpModalTitleEnabled = 'cro_sign_up_modal_without_save_up_to_70',
  refundProtectForInternationalEnabled = 'cro_refund_protect_vs_insurance_international',
  offerPageSecondChanceModal = 'offer_page_second_chance_modal',
  searchPageSecondChanceModal = 'search_page_second_chance_modal',
  specificPaidLandingPage = 'specific_paid_landing_page',
  croMultiItemCart = 'cro_multi_item_cart',
  securePhoneNumberChangeEnabled = 'csx_secure_phone_number_change',
  croInsuranceCopyWithCoverageDetails = 'cro_insurance_copy_with_coverage_details',
  croTrustpilotReviewFeedInCheckout = 'cro_trustpilot_review_feed_in_checkout',
  croLPFreePreviewAfterSignUpLogIn = 'cro_offer_lp_free_preview_after_sign_up_log_in',
  croLPPNewMobileBooking = 'cro_lpp_new_mobile_booking',
  croUrgencySavingUpsPricingHomepageSearch = 'cro_urgency_saving_usps_homepage_search',
  croAlwaysOnNewMobileBooking = 'cro_lpc_new_mobile_booking',
  croFlexibleFlightFares = 'cro_flexible_flight_fares',
  paymentsDepositOptionForHotelsAbove1999V2 = 'payments_deposit_option_for_hotels_above_1999_v2',
  croWebPushNotificationTrigger = 'cro_web_push_notification_trigger',
  croEmergingMarketTrustIndicatorsV2 = 'cro_emerging_markets_trust_v2',
  carHireBundledDiscountUpcomingOrderHomepageCarousel = 'car_hire_bundled_discount_upcoming_order_homepage_carousel',
  croStickyWalledGarden = 'cro_sticky_walled_garden',
  croPopularOptionBookingRemaining = 'cro_popular_option_booking_remaining',
  accommOfferCalendarWithoutPricing = 'accomm_offer_calendar_without_pricing',
  croDreamBlocksOnOfferPages = 'cro_dream_blocks_on_offer_pages',
  searchRankingValueTest = 'search_ranking_value_test',
  croBundledFlexibleFlightFaresV2 = 'cro_bundled_flexible_flight_fares_v2',
  lereFilterLowMpvCarousel = 'lere_filter_low_mpv_carousel',
  searchMpvSalesRanking = 'search_mpv_sales_ranking',
}

export enum OptimizelyFeatureFlags {
  luxLoyaltyFeatureToggle = 'lux_loyalty_feature_toggle',
  luxPlusFeatureToggle = 'luxplus_feature_toggle',
  luxPlusToursToggle = 'luxplus_tours_toggle',
  luxPlusDiscountedInsuranceBenefit = 'lux_plus_discounted_insurance_benefit',
  luxPlusDiscountedBookingProtectionBenefit = 'lux_plus_discounted_booking_protection_benefit',
  luxPlusLppPricingEnabled = 'luxplus_lpp_pricing_enabled',
  luxPlusCruiseInclusionsEnabled = 'lux_plus_cruise_inclusions',
  allowPhoneNumberLogin = 'allow_phone_number_login',
  promoAppBanner = 'app_banner_targeted_delivery',
  CSAgentsAutoQuote = 'cro_cs_agents_auto_quote',
  tourOptionalExtras = 'tours_optional_extras',
  tourReviewsEnabled = 'cro_tour_reviews',
  toursRequestAgentCallbackEnabled = 'csx_tours_request_agent_callback',
  hotelsAndVillasRequestAgentCallbackEnabled = 'csx_hotels_and_villas_request_agent_callback',
  tourOptionalExtraPostPurchase = 'tour_optional_extra_post_purchase',
  upsellTilesFeatureToggle = 'cro_upsell_on_homepage_and_my_escapes',
  croNewFlightsSaleCarouselEnabled = 'cro_flights_sale_carousel',
  croTravelPreferencesModalEnabled = 'cro_travel_preferences_modal',
  standaloneAirportTransfersEnabled = 'csx_standalone_airport_transfer_flow',
  opexTermsAndConditionsModal = 'terms_and_conditions_modal',
  lebtPinnedFlightDetails = 'lebt_pinned_flight_details',
  croWebPushNotificationPrompt = 'cro_web_push_notification_prompt',
  opexFraudOrdersOtp = 'opex_fraud_orders_otp',
  lebtMerchantFeesEnabled = 'lebt_merchant_fees',
  payIdTargetedRelease = 'pay_id_targeted_release',
  accomUsePropertyPageRatesEndpoint = 'accom_use_property_page_rates_endpoint',
  useSppPricingSearch= 'use_spp_pricing_search',
  isGeneratedTripsEnabled = 'is_generated_trips_enabled',
  marketplacePage = 'marketplace_page',
  carHireBundledDiscount = 'car_hire_bundled_discount',
  searchLebtRanking = 'search_lebt_ranking',
  lereHeroCarouselEnabled = 'lere_hero_carousel',
  searchMpvSalesRanking = 'search_mpv_sales_ranking',
  lebtServiceFeesEnabled = 'lebt_service_fees',
  opexHotelAddExtraGuestsEnabled = 'hotel_add_extra_guests',
}
